import { createFileRoute } from '@tanstack/react-router';
import { ImportResultPage } from '../../features/rates';

export const Route = createFileRoute('/portal/rates/imports/$id')({ component: ImportResultPage });
